import PlanImpressionPrixHelperController from './plan.impression.prix.helper.controller';

export default {
    bindings: {
        modalInstance: '<'
    },
    template: require('./plan.impression.prix.helper.html'),
    controller: PlanImpressionPrixHelperController
};
